export default {
  organizationReport (state, payload) {
    state.report = []
    state.organization = payload.organization
    state.time = payload.time
    payload.report.forEach((element, index) => {
      if (index === 0) {
        for (var property in element.no_corrective) {
          var report = {}
          report.label = property + ' corrective'
          report.data = [element.no_corrective[property]]
          report.backgroundColor = payload.colors[property]
          state.report.push(report)
          var data = {}
          data.label = property + ' currently'
          data.data = [element.no_rest[property]]
          data.backgroundColor = payload.colors[property]
          state.report.push(data)
        }
      } else {
        // eslint-disable-next-line no-redeclare
        for (var property in element.no_corrective) {
          state.report.forEach(r => {
            if (r.label === property + ' corrective') {
              r.data.push(element.no_corrective[property])
            }
          })
        }
        // eslint-disable-next-line no-redeclare
        for (var property in element.no_rest) {
          state.report.forEach(r => {
            if (r.label === property + ' currently') {
              r.data.push(element.no_rest[property])
            }
          })
        }
      }
    })
  },
  setType (state, payload) {
    state.type = payload.data.quarter
    state.start_year = payload.data.from_year
    state.end_year = payload.data.to_year
  },
  hashtagReport (state, payload) {
    state.report_hashtag = payload
  },
  reportCorrective (state, payload) {
    state.report_corrective = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/report/mutations.js